module.exports = __webpack_public_path__ + "media/images/filters-3b00f76b.svg";